import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=32b35ae1&scoped=true&"
var script = {}
import style0 from "./Navigation.vue?vue&type=style&index=0&id=32b35ae1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b35ae1",
  null
  
)

export default component.exports